// removed by extract-text-webpack-plugin
module.exports = {"hidden":"P9egz","visuallyhidden":"_34zKl","hide-text":"_2VQCD","center":"_2NSS2","noprint":"yFs9h","footer":"_2Z8Lj","flexcontainer":"ArGW3","terms":"_3k9fg","legal":"_1ZAJO"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/footer/styles/default.scss
 ** module id = 983
 ** module chunks = 2
 **/